module.exports = "../../../../platform/assets/pageMainIcon/industry_danjuweihulei4.svg";